module.exports = __webpack_public_path__ + "assets/es-PickingAudio.mp3";